import React from "react";
import {NavLink} from "react-router-dom";
import * as Utils from "../inc/Utils";
import MemberSidebar from "../inc/MemberSidebar";
import {confirmAlert} from "react-confirm-alert";
import moment from "moment-timezone";
import {Config} from "../Config";
import toast, {Toaster} from "react-hot-toast";

export default function Profile(prop) {

    let member = prop.member;
    let [data, setData] = React.useState(null);
    let [dataResearcher, setDataResearcher] = React.useState(false);
    let [dataEntrepreneur, setDataEntrepreneur] = React.useState(false);
    let [memberType, setMemberType] = React.useState(null);
    let [departmentType, setDepartmentType] = React.useState(null);
    let [allowPublishResearcher, setAllowPublishResearcher] = React.useState(false);
    let [allowPublishEntrepreneur, setAllowPublishEntrepreneur] = React.useState(false);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        document.title = 'ข้อมูลส่วนตัว - NCSA';

        (async function() {
            try {
                if(member) {
                    const resView = await Utils.getProfile(member);
                    setData(resView);

                    if(resView.memberTypeId === Utils.MEMBER_TYPE_REASEARCHER) {
                        const resResearcher = await Utils.getResearcherMember(member);
                        if(resResearcher) {
                            setDataResearcher(resResearcher.id);
                            setAllowPublishResearcher(resResearcher.memberStatus===1);
                        }
                    }
                    else if(resView.memberTypeId === Utils.MEMBER_TYPE_ENTREPRENEUR) {
                        const resEntrepreneur = await Utils.getEntrepreneurMember(member);
                        if(resEntrepreneur) {
                            setDataEntrepreneur(resEntrepreneur.id);
                            setAllowPublishEntrepreneur(resEntrepreneur.memberStatus===1);
                        }
                    }

                    const resMemberType = await Utils.getMemberType();
                    const resDepartmentType = await Utils.getDepartmentType();
                    setMemberType(resMemberType.filter(e => e.id === resView.memberTypeId)[0].title);
                    setDepartmentType(resDepartmentType.filter(e => e.id === resView.departmentTypeId)[0].title);
                }
            } catch (e) {
                //
            }
        })();

    }, []);

    const updateResearcherStatus = async (e) => {
        let status = e.target.checked;

        confirmAlert({
            title: 'แจ้งเตือน',
            message: status ? (prop.lang === 'en' ? 'Permission to publish your information on the website cybreplus.ncsa.or.th ?':'อนุญาติเผยแพร่ข้อมูลของท่าน บนหน้าเว็บไซต์ cybreplus.ncsa.or.th ?'):(prop.lang === 'en' ? 'Suspend the dissemination of information ?​':'ระงับการเผยแพร่ข้อมูล ?'),
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: () => {
                        const body = {
                            memberStatus: status ? 1:2,
                            updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                        };
                        fetch(Config.apiUrl +'/researcher/updateMemberStatus', {
                            method: 'POST',
                            body: JSON.stringify(body),
                            headers: {
                                'Content-Type':'application/json',
                                'x-access-token': member.accessToken
                            }
                        }).then(response => {
                            if(response.ok) {
                                return response.json();
                            }
                            else {
                                return response.json().then(err => Promise.reject(err));
                            }
                        }).then(result => {
                            if(result) {
                                setAllowPublishResearcher(status);
                                toast.success(status ? (prop.lang === 'en' ? 'Data has been published successfully.':'เผยแพร่ข้อมูลเรียบร้อย'):(prop.lang === 'en' ? 'The dissemination of information has been suspended.':'ระงับการเผยแพร่ข้อมูลเรียบร้อย'));
                            }
                        }).catch(err => {
                            toast.error(err.message);
                        })
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    const updateEntrepreneurStatus = async (e) => {
        let status = e.target.checked;

        confirmAlert({
            title: 'แจ้งเตือน',
            message: status ? (prop.lang === 'en' ? 'Permission to publish your information on the website cybreplus.ncsa.or.th ?':'อนุญาติเผยแพร่ข้อมูลของท่าน บนหน้าเว็บไซต์ cybreplus.ncsa.or.th ?'):(prop.lang === 'en' ? 'Suspend the dissemination of information ?​':'ระงับการเผยแพร่ข้อมูล ?'),
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: () => {
                        const body = {
                            memberStatus: status ? 1:2,
                            updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                        };
                        fetch(Config.apiUrl +'/entrepreneur/updateMemberStatus', {
                            method: 'POST',
                            body: JSON.stringify(body),
                            headers: {
                                'Content-Type':'application/json',
                                'x-access-token': member.accessToken
                            }
                        }).then(response => {
                            if(response.ok) {
                                return response.json();
                            }
                            else {
                                return response.json().then(err => Promise.reject(err));
                            }
                        }).then(result => {
                            if(result) {
                                setAllowPublishEntrepreneur(status);
                                toast.success(status ? (prop.lang === 'en' ? 'Data has been published successfully.':'เผยแพร่ข้อมูลเรียบร้อย'):(prop.lang === 'en' ? 'The dissemination of information has been suspended.':'ระงับการเผยแพร่ข้อมูลเรียบร้อย'));
                            }
                        }).catch(err => {
                            toast.error(err.message);
                        })
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="profile" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">

                            {
                                member && member.typeId === Utils.MEMBER_TYPE_RESEARCHER ?
                                    <>
                                        <h3 className="title-line-left mt-0 mb-4">{prop.lang === 'en' ? 'Research Information':'ข้อมูลการวิจัย'}</h3>
                                        <h6 className="pb-2"></h6>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <table className="table table-bordered">
                                                    <thead>
                                                    <tr>
                                                        <th className="text-center">{prop.lang === 'en' ? 'Member Type':'ประเภทผู้สมัคร'}</th>
                                                        <th></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td className="text-center">{memberType}</td>
                                                        <td className="text-center">
                                                            {
                                                                data?.memberTypeId === Utils.MEMBER_TYPE_REASEARCHER ?
                                                                    <NavLink className="btn btn-xs btn-gray" to={prop.lang === 'en' ? '/en/profile/researcher':'/profile/researcher'}>
                                                                        {prop.lang === 'en' ? 'Edit information published on the website':'แก้ไขข้อมูลที่เผยแพร่ในเว็บไซต์'}
                                                                    </NavLink> : ''
                                                            }

                                                            {
                                                                data?.memberTypeId === Utils.MEMBER_TYPE_ENTREPRENEUR ?
                                                                    <NavLink className="btn btn-xs btn-gray" to={prop.lang === 'en' ? '/en/profile/entrepreneur':'/profile/entrepreneur'}>
                                                                        {prop.lang === 'en' ? 'Edit information published on the website':'แก้ไขข้อมูลที่เผยแพร่ในเว็บไซต์'}
                                                                    </NavLink> : ''
                                                            }
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <h6 className="pb-2 mt-3">{prop.lang === 'en' ? 'Select Department':'กระทรวง/สังกัด'}</h6>
                                        <div className="row">
                                            <div className="col-md-4 col-sm-6">
                                                {data?.departmentTypeId === Utils.MEMBER_DEPARTMENT_YES ? data.department?.title : departmentType}
                                            </div>
                                        </div>

                                        <h6 className="pb-2 mt-4">{prop.lang === 'en' ? 'Research Type':'ประเภทของการวิจัย'}</h6>
                                        <div className="row g-3">
                                            <div className="col-12">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="checkbox" value="" id="radio3_1" name="radio3" checked={data?.basicResearch===1} disabled={true} />
                                                    <label className="form-check-label" htmlFor="radio3_1">
                                                        {prop.lang === 'en' ? 'Basic Research':'การวิจัยพื้นฐาน (Basic Research)'}
                                                    </label>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <div className="form-check lg">
                                                    <input className="form-check-input" type="checkbox" value="" id="radio3_2" name="radio3" checked={data?.appliedResearch===1} disabled={true} />
                                                    <label className="form-check-label" htmlFor="radio3_2">
                                                        {prop.lang === 'en' ? 'Applied Research':'การวิจัยประยุกต์ (Applied Research)'}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="py-3">
                                            <hr />
                                        </div>
                                    </> : ''
                            }

                            <h3 className="title-line-left mt-0 mb-4">{prop.lang === 'en' ? 'Profile':'ข้อมูลส่วนตัว'}</h3>
                            <div className="row g-3">
                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Id Card Number':'เลขประจำตัวประชาชน'}</h6>
                                        {data?.idcard}
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Prefix':'คำนำหน้านาม'} </h6>
                                        {prop.lang === 'en' ? data?.prefix.title_en:data?.prefix.title}
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Firstname':'ชื่อจริง'} <span className="star">*</span></h6>
                                        {data?.firstname}
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Lastname':'นามสกุล'}</h6>
                                        {data?.lastname}
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Email':'อีเมล'}</h6>
                                        {data?.email}
                                    </div>
                                </div>

                                <div className="col-sm-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Phone':'หมายเลขโทรศัพท์มือถือ'}</h6>
                                        {data?.phone}
                                    </div>
                                </div>

                                <div className={"col-sm-12" + (dataResearcher ? '':' d-none')}>
                                    <div className="form-check lg">{}
                                        <input className="form-check-input" type="checkbox" value="" id="radio_public" name="radio_public" checked={allowPublishResearcher} onChange={e => updateResearcherStatus(e)} />
                                        <label className="form-check-label" htmlFor="radio_public">
                                            {prop.lang === 'en' ? 'Permission to publish your information on the website cybreplus.ncsa.or.th':'อนุญาติเผยแพร่ข้อมูลของท่าน บนหน้าเว็บไซต์ cybreplus.ncsa.or.th'}
                                        </label>
                                    </div>
                                </div>

                                <div className={"col-sm-12" + (dataEntrepreneur ? '':' d-none')}>
                                    <div className="form-check lg">{}
                                        <input className="form-check-input" type="checkbox" value="" id="radio_public" name="radio_public" checked={allowPublishEntrepreneur} onChange={e => updateEntrepreneurStatus(e)} />
                                        <label className="form-check-label" htmlFor="radio_public">
                                            {prop.lang === 'en' ? 'Permission to publish your information on the website cybreplus.ncsa.or.th':'อนุญาติเผยแพร่ข้อมูลของท่าน บนหน้าเว็บไซต์ cybreplus.ncsa.or.th'}
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <div className="buttons gap-15 pb-0 my-sm-4">
                                <NavLink className="btn btn-gray w-130" to={prop.lang === 'en' ? '/en/editProfile':'/editProfile'}>
                                    {prop.lang === 'en' ? 'Edit Profile':'แก้ไขข้อมูล'}
                                </NavLink>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 